import CancelOrder from "./CancelOrder";
import GenerateInvoice from "../utils/GenerateInvoice";
import OrderDetails from "./OrderDetails";
import CallButton from "../utils/CallButton";
import ScanButton from "../utils/ScanButton";
import SwitchDriver from "./SwitchDriver";

const DriverOrders = ({ orders, setModal, onReRender }) => {
  return (
    <div id="driver-scroll" className="order-list-col">
      {Array.isArray(orders) &&
        orders?.map((order, index) => {
          return (
            <div
              className="card p-1 border-dashed-primary"
              key={order?.orderId ?? index}
            >
              <div className="p-2 border-bottom border-block-end-dashed">
                <div className="d-flex align-items-start justify-content-between gap-2">
                  <ScanButton setModal={setModal} orderId={order?.orderId} />
                  <OrderDetails orderId={order?._id} />
                  {order?.status < 4 && <CancelOrder orderId={order?._id} onReRender={onReRender} />}
                  {order?.status >= 4 && <CallButton phoneNumber={order?.driverPhone} />}
                  <GenerateInvoice orderId={order?._id} btnWidth={25} />
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    <div className="d-flex">
                      <div>
                        <span className="avatar avatar-lg avatar-rounded me-1 mt-1">
                          <img
                            src={`${process.env.REACT_APP_API_PUBLIC_URL}${order?.driverPhoto}`}
                            alt="img"
                          />
                        </span>
                      </div>
                      <div className="pt-1">
                        <div className="mb-1 h6 fs-10">DRIVER</div>
                        <div className="mb-1 h6">{order?.driverName}</div>
                        <div className="mb-1 h5 fs-10">
                          <i className="ri-phone-line me-1 fw-medium align-middle"></i>
                          {order?.driverPhone}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-end">
                    <div className="mb-1 h6 fs-10">{order?.orderId}</div>
                    <div className="mb-1 h4 fs-30">
                      <i
                        onClick={() => {
                          setModal({
                            open: true,
                            orderId: order?.orderId,
                            customerName: order?.orderId,
                          });
                        }}
                        className="ri-qr-code-line fw-medium align-middle cursor-pointer"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-3 border-top border-block-start-dashed">
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    <div className="mb-1 h6 fs-10">CUSTOMER</div>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    <div className="mb-1 h5 fs-10">
                      <i className="ri-phone-line me-1 fw-medium align-middle"></i>
                      {order?.customerPhone}
                    </div>
                    <div className="mb-1 h5 fs-10">
                      <i className="ri-map-pin-line me-1 fw-medium align-middle"></i>
                      {order?.area}, Block {order?.block}, {order?.street}
                    </div>
                  </div>
                </div>
              </div>
              <SwitchDriver
                orderId={order?._id}
                orderDateTime={order?.orderDateTime}
                onReRender={onReRender}
                variant="block"
              />
            </div>
          );
        })}
    </div>
  );
};

export default DriverOrders;
